import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import React, { FC } from 'react';
import { RATING_COLOR_HASH } from '../../utils';

const options = {
  chart: {
    type: 'bar',
    height: 168,
    style: {
      fontFamily: 'var(--font-family)',
    },
  },
  title: {
    text: undefined,
  },
  xAxis: {
    categories: [
      /* 'Social Media', 'On board', 'FinTech Security' */
    ],
  },
  legend: {
    align: 'right',
    verticalAlign: 'top',
    layout: 'vertical',
    y: 25,
    x: 16,
  },
  yAxis: {
    min: 0,
    title: {
      text: undefined,
    },
  },
  plotOptions: {
    series: {
      stacking: 'percent',
    },
    bar: {
      showInLegend: false,
    },
  },

  colors: Object.values(RATING_COLOR_HASH),
  series: [
    /* {
      name: 'Very Satisfied',
      data: [50, 30, 40],
    },
    {
      name: 'Satisfied',
      data: [20, 15, 50],
    },
    {
      name: 'Neutral',
      data: [15, 25, 5],
    },
    {
      name: 'Dissatisfied',
      data: [10, 20, 5],
    },
    {
      name: 'Very Dissatisfied',
      data: [5, 10, 0],
    },
  */
  ],
};

interface Props {
  data: { series: { name: string; data: number[] }[]; categories: string[] };
}

export const Chart: FC<Props> = ({ data: { categories, series } }) => (
  <HighchartsReact
    highcharts={Highcharts}
    options={{ ...options, series, xAxis: { categories } }}
  />
);
